package com.milta.core.localization.translations.de

import com.milta.core.localization.WebImportRouteStrings

internal val WebImportRoute = WebImportRouteStrings(
    headerSubtitle = "Laden Sie eine Lieferdatei hoch und weisen Sie sie einem Fahrer zu",
    stepImport = "Importieren",
    stepVerifyAssign = "Prüfen & zuweisen",
    stepValidateSend = "Touren bestätigen und senden",
    dropzoneTitle = "Ziehen Sie Ihre Lieferdatei per Drag & Drop hierher",
    dropzoneOrPrefix = "oder",
    browseFilesLink = "durchsuchen Sie Ihre Dateien",
    browseFilesButton = "Dateien durchsuchen",
    constraintsLabel = "Excel (.xlsx, .xls), CSV oder PDF · max. 500 Stopps · 10 MB",
    expectedColumnsEyebrow = "Erwartete Spalten in der Datei",
    columnRecipientName = "Name des Empfängers",
    columnAddress = "Vollständige Adresse",
    columnDeadline = "Zeitlimit",
    columnPhone = "Telefon",
    requiredPillLabel = "Erforderlich",
    optionalPillLabel = "Optional",
    analysingLabel = "Wird analysiert…",
    analysingCanLeaveLabel = "Datei gesendet. Sie können diese Seite verlassen, die Analyse läuft weiter.",
    importOnMobileMessage = "In der mobilen App läuft ein Import (%s). Schließen Sie ihn in der App ab, um hier eine andere Datei zu importieren.",
    invalidFileTitle = "Datei unleserlich oder Format nicht unterstützt",
    invalidFileMessage = "„%s\" konnte nicht analysiert werden. Verwenden Sie eine Excel- (.xlsx, .xls), CSV- oder PDF-Datei, die den erwarteten Spalten entspricht.",
    chooseAnotherFileButton = "Andere Datei auswählen",
    extractionFailedTitle = "Lieferungen können nicht extrahiert werden",
    extractionFailedMessage = "Die Datei „%s\" wurde gelesen, es wurde jedoch keine verwendbare Zeile gefunden. Prüfen Sie, ob sie die erwarteten Spalten enthält.",
    serviceUnavailableTitle = "Analysedienst vorübergehend nicht verfügbar",
    serviceUnavailableMessage = "Wir können Ihre Datei momentan nicht analysieren. Ihre Datei bleibt gespeichert: Versuchen Sie es in Kürze erneut.",
    retryButton = "Erneut versuchen",
    fileImportedStatus = "Datei importiert",
    stopsDetectedSuffix = "Stopps erkannt",
    replaceFileLink = "↺ Ersetzen",
    assignToEyebrow = "Zuweisen an",
    selectDriverRequiredError = "Bitte wählen Sie mindestens einen Fahrer aus, bevor Sie die Tour senden.",
    selectedDriversCountSuffix = "Fahrer ausgewählt",
    optimizeRouteButton = "Route optimieren",
    tableCaptionLead = "Überprüfen und korrigieren Sie die Stopps vor dem Senden",
    tableCaptionHint = "Klicken Sie auf das Stiftsymbol, um eine Zeile zu korrigieren",
    locationBlockedHint = "Jede Zeile benötigt vor dem Senden an die Fahrer eine lokalisierte Adresse (GPS). Bearbeite die betroffenen Zeilen (✎) oder wiederhole die Geokodierung.",
    columnHeaderIndex = "#",
    columnHeaderRecipientName = "Name des Empfängers",
    columnHeaderAddress = "Adresse",
    columnHeaderPhone = "Telefon",
    columnHeaderDeadline = "Zeitlimit",
    columnHeaderPackageCount = "Pakete",
    dashPlaceholder = "—",
    discardDraftButton = "Import verwerfen",
    discardDraftDialogTitle = "Diesen Import verwerfen?",
    discardDraftDialogMessage = "Die bereits importierten Lieferungen gehen endgültig verloren. Diese Aktion kann nicht rückgängig gemacht werden.",
    discardDraftConfirmButton = "Ja, Import verwerfen",
    freeFormatBanner = "Freies Format erkannt — die Spalten konnten nicht automatisch erkannt werden, überprüfen Sie jede Zeile vor dem Senden.",
    incompleteStopsBannerSuffix = "unvollständige Stopps — fehlender Name oder Adresse, vor dem Senden zu korrigieren.",
    rowFlagMissingName = "⚠ Name fehlt",
    rowFlagMissingAddress = "⚠ Adresse fehlt",
    alreadyDispatchedBanner = "Diese Tour wurde bereits an einen Fahrer gesendet — aktualisieren Sie die Seite, um einen neuen Import zu starten.",
    routeNotFoundError = "Tour nicht gefunden. Aktualisieren Sie die Seite und versuchen Sie es erneut.",
    validationErrorGeneric = "Bitte überprüfen Sie die eingegebenen Informationen.",
    submitServerError = "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    submitOptimizationUnavailableError = "Optimierungsdienst vorübergehend nicht verfügbar. Die Tour wurde nicht erstellt — versuchen Sie es in Kürze erneut.",
    sendWithoutOptimizationButton = "Ohne Optimierung senden",
    dispatchSuccessMessage = "Tour erfolgreich an %s gesendet",
    dispatchSuccessBatchMessage = "Touren erfolgreich an %d Fahrer gesendet",
    tooManyStopsError = "Diese Datei enthält mehr als 500 Lieferungen. Bitte teilen Sie sie vor dem Import auf.",
    resultHeaderMiddle = "Lieferungen aufgeteilt zwischen",
    resultDriverSingularSuffix = "Fahrer",
    resultDriverPluralSuffix = "Fahrern",
    resultDistanceLabel = "Distanz",
    resultDurationLabel = "Geschätzte Dauer",
    resultMetricNotCalculatedLabel = "Nicht berechnet",
    resultStopsChipSuffix = "Stopps",
    resultMoreStopsTemplate = "+ %d weitere Stopps",
    resultStopsLoadError = "Die Stopps dieser Tour konnten nicht geladen werden.",
    resultDispatchButton = "Touren bestätigen und senden",
)
